import { useRef, useState } from 'react'
import { ElectricBorder } from './ElectricBorder'
import './ElectricProductImage.css'

// Colours follow the current catalogue artwork, not the order ID or the prize.
// Unknown replacement artwork uses the same ice-blue as level one.
const artworkColors = {
  '1780418192953.jpg': '#85d9ff',
  '1780418177437.jpg': '#76ff40',
  '1780418162712.jpg': '#28c5ff',
  '1780418146990.jpg': '#a75cff',
  '1780418134010.jpg': '#ffac38',
}
export const productElectricColor = (src, type) => type === 'topup'
  ? '#a75cff'
  : artworkColors[String(src || '').split(/[?#]/)[0].split('/').pop()] || '#85d9ff'

export const hasRandomGameCode = order => Boolean(order?.completed ||
  (typeof order?.login === 'string' && order.login.trim() && order.login !== 'ERROR BY PAYMENT') ||
  (Array.isArray(order?.codes) && order.codes.length))

export function ElectricProductImage({ src, alt = 'Gift Card', active = false, type = 'random' }) {
  const frame = useRef(null)
  const [loadedSrc, setLoadedSrc] = useState(null)
  return <span className='electric-product-image' ref={frame}>
    <img src={src} alt={alt} onLoad={() => setLoadedSrc(src)} onError={() => setLoadedSrc(null)} />
    <ElectricBorder hostRef={frame} active={active && loadedSrc === src} color={productElectricColor(src, type)} />
  </span>
}
